// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RuBy","top":"styles_top__2bucx","left":"styles_left__1nmce","description":"styles_description__3SbqX"};